import React from "react";

import { Button, Menu, MenuItem, Typography } from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import { withStyles } from "@material-ui/core/styles";

import Spacer from "components/Spacer";

import { useAppDispatch, useAppSelector } from "store";
import {
    selectCustomSelectionStoresSort,
    setCustomSelectionStoresSort,
    StoreSortField
} from "modules/customer/insights/portfolio/filters/filtersSlice";
import { SortDirection } from "utils/sortUtils";

const StyledMenu = withStyles(theme => ({
    list: {
        width: theme.spacing(25)
    }
}))(Menu);

const StyledMenuItem = withStyles(theme => ({
    root: {
        fontWeight: (props: any) => props["data-current"] ? "bold" : "normal",
        color: (props: any) => props["data-current"] ? theme.palette.text.primary : theme.palette.text.disabled
    }
}))(MenuItem);

const Sort: React.FC = () => {
    const dispatch = useAppDispatch();
    const customSelectionStoresSort = useAppSelector(selectCustomSelectionStoresSort);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSortClick = (field: StoreSortField) => () => {
        let direction = SortDirection.ASC;
        if (customSelectionStoresSort.field === field) {
            direction = customSelectionStoresSort.direction === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
        }
        const newCustomSelectionStoresSort = { ...customSelectionStoresSort, field, direction };
        dispatch(setCustomSelectionStoresSort(newCustomSelectionStoresSort));
    };

    return (
        <>
            <Button
                variant="text"
                size="small"
                color="default"
                disableElevation
                startIcon={<ArrowDownwardIcon />}
                onClick={handleClick}
                data-cy="btn-sort"
            >
                Sort
            </Button>
            <StyledMenu
                open={open}
                onClose={handleClose}
                variant="menu"
                keepMounted
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
            >
                <StyledMenuItem onClick={handleSortClick(StoreSortField.Name)} data-current={customSelectionStoresSort.field === StoreSortField.Name}>
                    <Typography variant="body1" component="div">
                        Store name
                    </Typography>
                    <Spacer />
                    <Typography variant="body1" component="div">
                        {customSelectionStoresSort.field !== StoreSortField.Name || customSelectionStoresSort.direction === SortDirection.ASC ? "A-Z" : "Z-A"}
                    </Typography>
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.TotalScore)} data-current={customSelectionStoresSort.field === StoreSortField.TotalScore}>
                    <Typography variant="body1" component="div">Total score</Typography>
                    <Spacer />
                    {customSelectionStoresSort.field !== StoreSortField.TotalScore || customSelectionStoresSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.SalesScore)} data-current={customSelectionStoresSort.field === StoreSortField.SalesScore}>
                    <Typography variant="body1" component="div">Sales score</Typography>
                    <Spacer />
                    {customSelectionStoresSort.field !== StoreSortField.SalesScore || customSelectionStoresSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.DriversScore)} data-current={customSelectionStoresSort.field === StoreSortField.DriversScore}>
                    <Typography variant="body1" component="div">Driver score</Typography>
                    <Spacer />
                    {customSelectionStoresSort.field !== StoreSortField.DriversScore || customSelectionStoresSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.ProfitScore)} data-current={customSelectionStoresSort.field === StoreSortField.ProfitScore}>
                    <Typography variant="body1" component="div">Profit score</Typography>
                    <Spacer />
                    {customSelectionStoresSort.field !== StoreSortField.ProfitScore || customSelectionStoresSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.AreaHealthScore)} data-current={customSelectionStoresSort.field === StoreSortField.AreaHealthScore}>
                    <Typography variant="body1" component="div">Area health score</Typography>
                    <Spacer />
                    {customSelectionStoresSort.field !== StoreSortField.AreaHealthScore || customSelectionStoresSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.CompetitionScore)} data-current={customSelectionStoresSort.field === StoreSortField.CompetitionScore}>
                    <Typography variant="body1" component="div">Competition score</Typography>
                    <Spacer />
                    {customSelectionStoresSort.field !== StoreSortField.CompetitionScore || customSelectionStoresSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoreSortField.CatchmentScore)} data-current={customSelectionStoresSort.field === StoreSortField.CatchmentScore}>
                    <Typography variant="body1" component="div">Catchment score</Typography>
                    <Spacer />
                    {customSelectionStoresSort.field !== StoreSortField.CatchmentScore || customSelectionStoresSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
            </StyledMenu>
        </>
    );
};

export default Sort;
